/** Public contract for mutable, platform-managed Work cover display metadata. */
import { z } from "zod";
import { canonicalIdSchema } from "./content.ts";

export const workCoverSchema = z
  .object({
    url: z.url().refine((value) => {
      const url = new URL(value);
      return (
        url.protocol === "https:" ||
        (url.protocol === "http:" &&
          (url.hostname === "127.0.0.1" || url.hostname === "localhost"))
      );
    }, "Cover URLs must use HTTPS except on localhost"),
    width: z.number().int().positive().nullable(),
    height: z.number().int().positive().nullable(),
    alt: z.string().min(1)
  })
  .strict()
  .nullable()
  .default(null);

export const workCoverMutationResponseSchema = z
  .object({
    workId: canonicalIdSchema,
    cover: workCoverSchema
  })
  .strict();

export type WorkCover = z.infer<typeof workCoverSchema>;
export type WorkCoverMutationResponse = z.infer<
  typeof workCoverMutationResponseSchema
>;
